import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { advisorReferralsApi } from '../api/advisorReferralsApi';
import type { ReferAdvisorPayload } from '../types/advisor-referrals.types';

export const advisorReferralKeys = {
  all: ['advisorReferrals'] as const,
  eligibleClients: () => [...advisorReferralKeys.all, 'eligibleClients'] as const,
};

export const useEligibleAdvisorReferralClients = (enabled: boolean) =>
  useQuery({
    queryKey: advisorReferralKeys.eligibleClients(),
    queryFn: advisorReferralsApi.getEligibleClients,
    enabled,
  });

export const useReferAdvisor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ReferAdvisorPayload) => advisorReferralsApi.referAdvisor(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: advisorReferralKeys.eligibleClients() });
    },
  });
};
